/**
 * @generated SignedSource<<40cb919def488859c15ad796ac1f3227>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespIconBubblesWrapper_item$data = {
  readonly isPublishedPrivate: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespIconBubbleDesignManager_item" | "PdpRespIconBubbles_item">;
  readonly " $fragmentType": "PdpRespIconBubblesWrapper_item";
};
export type PdpRespIconBubblesWrapper_item$key = {
  readonly " $data"?: PdpRespIconBubblesWrapper_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespIconBubblesWrapper_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespIconBubblesWrapper_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isPublishedPrivate",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespIconBubbles_item"
    },
    {
      "condition": "isTrade",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespIconBubbleDesignManager_item"
        }
      ]
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "931b850a555c97195d480e940d7103ea";

export default node;
